
const Index = () => import("./cost-variables/index.vue");
const CreatePage = () => import("./cost-variables/_pages/create.vue");
const ViewPage = () => import("./cost-variables/_pages/view.vue");
// sale invoices
const SaleInvoicesIndex = () => import("./sale-invoices/index.vue");
const NewSaleInvoice = () => import("./sale-invoices/new-invoice.vue");
const ViewSaleInvoice = () => import("./sale-invoices/preview.vue");
const EditSaleInvoice = () => import("./sale-invoices/edit-invoice.vue");

// profit reports
const ProfitReportsIndex = () => import("./profit-reports/index.vue");
const InvoicesProfitReport = () => import("./profit-reports/invoices-profit.vue");
const ProfitPerProductsReport = () => import("./profit-reports/products-profit.vue");

export default [
  {
    path: "/export-profit-margin-report",
    component: ProfitReportsIndex,
  },
  {
    path: "/export-invoices-profit",
    component: InvoicesProfitReport,
  },
  {
    path: "/export-products-profit",
    component: ProfitPerProductsReport,
  },
  {
    path: "/export-sale-invoices",
    component: SaleInvoicesIndex,
  },
  {
    path: "/new-export-invoice",
    component: NewSaleInvoice,
  },
  {
    path: "/export-sale-invoices/:id",
    component: ViewSaleInvoice,
  },
  {
    path: "/edit-export-invoice/:id",
    component: EditSaleInvoice,
  },
  {
    path: "/cost-variables",
    component: Index,
  },
  {
    path: "/new-cost-variable",
    component: CreatePage,
  },
  {
    path: "/cost-variables/:id",
    component: ViewPage,
  },
];
